import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Box, IconButton } from "@mui/material";

// E5 design toast: success ~3.5 s, error ~6 s
export const TOAST_DURATION = { success: 3500, error: 6000 };

const TOAST_STYLE = {
  success: { bg: "#ecfdf3", border: "#abefc6", color: "#067647", glyph: "✓" },
  error: { bg: "#fef3f2", border: "#fecdca", color: "#b42318", glyph: "!" },
};

/**
//    * @component  Message Component
//    * @description Toast for success and error messages, top-centre, styled per the E5 design.
//    * @returns Message Component UI
//    */
function MessageComp(props) {
  const [showMsg, setShowMsg] = useState(false);
  const [msgContent, setMsgContent] = useState({
    msg: "",
    type: "",
  });
  const timerRef = useRef(null);

  /**
   * show the message and hide it after the design duration; a new message restarts the timer
   */
  useEffect(() => {
    clearTimeout(timerRef.current);
    const content = props.msg || {};
    setMsgContent(content);
    setShowMsg(!!props.show && !!content.msg);
    if (props.show && content.msg) {
      const duration =
        content.type === "success" ? TOAST_DURATION.success : TOAST_DURATION.error;
      timerRef.current = setTimeout(() => setShowMsg(false), duration);
    }
    return () => clearTimeout(timerRef.current);
  }, [props.show, props.msg]);

  const onClose = () => {
    clearTimeout(timerRef.current);
    setShowMsg(false);
  };

  if (!showMsg) {
    return <></>;
  }

  const look = msgContent.type === "success" ? TOAST_STYLE.success : TOAST_STYLE.error;

  return (
    <Box
      role={msgContent.type === "success" ? "status" : "alert"}
      sx={{
        position: "fixed",
        top: props.loginPage ? 24 : 96,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1400,
        display: "flex",
        alignItems: "center",
        gap: "12px",
        backgroundColor: look.bg,
        border: `1px solid ${look.border}`,
        color: look.color,
        borderRadius: "8px",
        p: "12px 16px 12px 14px",
        boxShadow: "0 8px 24px rgba(16,24,40,.14)",
        fontSize: 12,
        maxWidth: "calc(100% - 32px)",
        boxSizing: "border-box",
      }}
    >
      <Box
        component="span"
        aria-hidden="true"
        sx={{
          flexShrink: 0,
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: look.color,
          color: "#fff",
          fontSize: 10,
          fontWeight: 700,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {look.glyph}
      </Box>
      <span className="msgContent">{msgContent.msg}</span>
      <IconButton
        aria-label="close"
        size="small"
        onClick={onClose}
        sx={{ color: look.color, fontSize: 13, lineHeight: 1, p: "2px 6px" }}
      >
        ×
      </IconButton>
    </Box>
  );
}

MessageComp.propTypes = {
  msg: PropTypes.object,
  id: PropTypes.string,
  show: PropTypes.bool,
  loginPage: PropTypes.bool,
};
export default MessageComp;
